module.exports = __webpack_public_path__ + "ubuntu-italic-webfont.68f086e02e8ef7b3a1f6.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ubuntu/ubuntu-italic-webfont.woff2
// module id = ./src/assets/webfonts/ubuntu/ubuntu-italic-webfont.woff2
// module chunks = styles